import { useLocation } from 'react-router-dom';
import { useDriverTour, TourButton } from '@resort-os/ui';
import { posProductsTour } from '../tours/productsTour';
import { posOrdersTour } from '../tours/ordersTour';
import { posHistoryTour } from '../tours/historyTour';
import { posTablesTour } from '../tours/tablesTour';
import type { DriveStep } from 'driver.js';

const tourConfigs: Record<string, DriveStep[]> = {
  '/': posProductsTour,
  '/products': posProductsTour,
  '/orders': posOrdersTour,
  '/history': posHistoryTour,
  '/tables': posTablesTour,
};

export default function TourWrapper() {
  const location = useLocation();
  const steps = tourConfigs[location.pathname];

  const tourKey = `pos-${location.pathname}`;
  const { startTour, showHint } = useDriverTour({
    steps: steps ?? [],
    tourKey,
  });

  if (!steps) return null;

  return (
    <TourButton onStart={startTour} tourKey={tourKey} showPulse={showHint} label="Take a tour" />
  );
}
